<template>
  <div style="padding: 16px">
    <Tabs
      v-model="tabsValue"
      @on-click="handleTapChange"
      style="margin-top: 20px"
    >
      <TabPane
        v-for="(item, index) in cpList2"
        :label="item.name"
        :name="item.name"
        :key="index"
      ></TabPane>
    </Tabs>
    <el-form :inline="true" :model="formFuzzy">
      <el-form-item>
        <el-input
          v-model="formFuzzy.albumName"
          placeholder="输入专辑名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onQuery" icon="el-icon-search"
          >搜索</el-button
        >
      </el-form-item>
      <el-button
        class="btn_multy_add_new_book"
        v-show="showAddBtn"
        type="primary"
        @click="addAlbum"
        icon="el-icon-circle-plus-outline"
        >新建专辑</el-button
      >
    </el-form>
    <el-table
      ref="multipleTable"
      :data="queryData"
      :header-cell-style="rowClass"
      tooltip-effect="dark"
      style="width: 100%; font-size: 12px"
      @selection-change="handleSelectionChange"
      v-loading.body="loading"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="id" label="专辑ID" align="center" width="100">
        <template slot-scope="scope">
          <a
            href="javascript:;"
            @click="gotoAlbum(scope.row)"
            style="color: #1d90e6"
            >{{ scope.row.id }}</a
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="专辑名称"
        align="center"
        min-width="150"
        sortable
      >
        <template slot-scope="scope">
          <a
            href="javascript:;"
            @click="gotoAlbum(scope.row)"
            style="color: #1d90e6"
            >{{ scope.row.name }}</a
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="dbName"
        label="书籍品牌"
        align="center"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="res_count"
        label="内容数量"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="上下架状态"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0" type="danger">未上架</el-tag>
          <el-tag v-else-if="scope.row.status == 1" type="gray">已上架</el-tag>
          <el-tag v-else-if="scope.row.status == 2" type="success"
            >被下架</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="editor"
        label="编辑账号"
        min-width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="updated_at"
        label="更新时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updated_at | formatDate2 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        show-overflow-tooltip
        align="center"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
              @click="handleEdit(scope.row)"
              :disabled="scope.row.editAble == 0 ? true : false"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-button
      type="primary"
      @click="shangjia"
      style="margin-top: 10px"
      v-show="showAddBtn"
      icon="el-icon-arrow-up"
      >上架</el-button
    >
    <el-button
      type="info"
      @click="xiajia"
      v-show="showAddBtn"
      icon="el-icon-arrow-down"
      >下架</el-button
    >
    <el-button
      type="primary"
      @click="syncAlbumHandle"
      v-if="tabsValue == '预置歌单'"
      icon="el-icon-sort"
      >同步</el-button
    >
    <el-button
      type="danger"
      @click="delAlbums"
      v-show="showAddBtn"
      icon="el-icon-delete"
      >删除</el-button
    >
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryParams.page"
        :page-sizes="[20, 50, 100]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import { deepObjectCopy } from "@/utils/tools";
export default {
  name: "albumList",
  data() {
    return {
      loading: true,
      currentStatus: "",
      queryData: [],
      formFuzzy: {
        albumId: "",
        albumName: "",
        albumBrand: "",
        state: "",
      },
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      cpList: [],
      cpList2: [],
      multipleSelection: [],
      tabsValue: "",
      currCpId:'',
      getSystemAlbum: false,
      showAddBtn: false,
      appName: "",
      haveEditCPRight: false,
      allCPList: [],
      allshareCPList: [],
      queryDatas:[],
      newer:[],
      IDers:[]
    };
  },
  components: {},
  props: {},
  created() {
    this.appName = JSON.parse(sessionStorage.getItem("currentApp")).name;
    // this.fetchCPList();
    // this.fetchQueryData();
    this.initCplist();
  },
  computed: {},
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {
    this.fetchQueryData()
  },
  watch: {},
  methods: {
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    fetchQueryData() {
      let params ;
      let cpid = [];
      cpid.push(this.formFuzzy.cpId);
      params = {
        appId: this.$API.APPID,
        owner: this.IDers.id,
      };
      // if (this.currCpId != null) {
      //   params.dbId = this.currCpId;
      // }
      if (this.formFuzzy.albumId != "") {
        let albumId = [];
        albumId.push(Number(this.formFuzzy.albumId));
        params.id = albumId;
      }
      let cpidList = [];
      if (this.formFuzzy.cpId != "") {
        cpidList.push(Number(this.formFuzzy.cpId));
      } else {
        this.allAllCp(cpidList);
      }
      params.dbId = cpidList;
      if (this.formFuzzy.albumName != "") {
        params.name = this.formFuzzy.albumName;
      }
      if (this.formFuzzy.albumBrand != "") {
        params.dbId = this.formFuzzy.albumBrand;
      }
      if (typeof this.formFuzzy.state == "number") {
        params.status = this.formFuzzy.state;
      }
      if (this.getSystemAlbum) {
        params.otype = 0;
      }
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.$axios
        .post("/aries-api/album/list", params)
        .then((response) => {
          if (response.data.result == 0) {
            this.queryData = response.data.data.list;
            this.pageTotal = response.data.data.pager.total;
            // this.queryData.forEach((item,index)=>{
            //   this.queryDatas.forEach((x,y)=>{
            //     if(item.owner==x.id){
            //       this.newer.push(item)
            //     }

            //   })
            // })
            this.loading = false;
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    allAllCp(cpid) {
      for (let i = 0; i < this.cpList.length; ++i) {
        cpid.push(this.cpList[i].id);
      }
    },
    addAlbum() {
      this.$router.push({
        name: "addAlbum",
        query: {
          cpid: this.currCpId,
          do: "add",
          isSystem: this.getSystemAlbum,
        },
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchQueryData();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchQueryData();
    },
    delAlbums() {
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除专辑</li></ul>",
        onOk: () => {
          if (this.multipleSelection.length == 0) {
            alert("请先勾选专辑");
            return;
          }
          let ids = [];
          for (let i = 0; i < this.multipleSelection.length; ++i) {
            let idDel = this.multipleSelection[i].id;
            ids.push(idDel);
          }
          let params = {
            appId: this.$API.APPID,
            ids: ids,
          };
          this.$axios
            .post("/aries-api/album/delete", params)
            .then((response) => {
              let m = response.data;
              if (m.result == 0) {
                this.fetchQueryData();
                this.$Message.success("删除成功!");
              } else {
                ApiMessage(this, m.msg, "error");
              }
            })
            .catch((error) => {
              ApiMessage(this, error.toString(), "error");
            });
        },
      });
    },
    handleEdit(album) {
      let cpId = Number(album.owner);
      let routeUrl = this.$router.resolve({
        name: "addAlbum",
        query: {
          cpid: cpId,
          albumId: album.id,
          do: "edit",
        },
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({
      //   name: "addAlbum",
      //   query: {
      //     cpid: cpId,
      //     albumId: album.id,
      //     do: "edit",
      //   },
      // });
    },
    sendOnlineRequest(online) {
      if (this.multipleSelection.length == 0) {
        alert("请先勾选专辑");
        return;
      }
      let ids = [];
      for (let i = 0; i < this.multipleSelection.length; ++i) {
        let id = this.multipleSelection[i].id;
        ids.push(id);
      }
      let params = {
        appId: this.$API.APPID,
        ids: ids,
        status: online,
      };
      this.$axios
        .post("/aries-api/album/online", params)
        .then((response) => {
          if (response.data.result == "0") {
            this.fetchQueryData();
            this.$Message.success("操作成功!");
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    shangjia() {
      this.sendOnlineRequest(1);
    },
    xiajia() {
      this.sendOnlineRequest(0);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    initCplist() {
      let params = {
        appId: this.$API.APPID,
        //otype: 2,
        dtype: 1,
        onlyAuthorised: 1,
        needAppName: 1,
      };
      this.$axios
        .post("/aries-api/resourceDb/list", params)
        .then((response) => {
          if (response.data.data.length!= 0&&response.data.data.own&&response.data.data.own.length!=0) {
            console.log(response.data.data.length);
              this.allshareCPList = response.data.data.own;
              this.setCPList();
          }else{
            this.loading=false
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    setCPList() {
        this.cpList = this.allshareCPList;
      this.fetchCPList();
    },
    fetchCPList() {
      // this.cpList = JSON.parse(sessionStorage.getItem("cpList"));
      this.cpList2 = deepObjectCopy(this.cpList);
      let IDers=[]
      this.cpList2.map((item)=>{
        this.IDers.push(item.id)
      })
      let temp = { name: "预置歌单" };
      // this.cpList2.splice(0, 0, temp);
      temp = { name: "全部" };
      this.cpList2.splice(0, 0, temp);
      this.formFuzzy.cpId = "";
      this.tabsValue = this.cpList2[0].name;
      this.fetchQueryData();
    },
    onQuery() {
      this.queryParams.page = 1;

      this.fetchQueryData();
    },
    handleTapChange(tabName) {
      this.getSystemAlbum = false;
      if (tabName == "全部") {
        this.currCpId = null;
        this.formFuzzy.cpId=''
        this.showAddBtn = false;
      } else if (tabName == "预置歌单") {
        this.currCpId = null;
        this.getSystemAlbum = true;
        if (this.appName == "内容提供商") {
          this.showAddBtn = true;
        } else {
          this.showAddBtn = false;
        }
      } else {
        this.showAddBtn = true;
        for (let i = 0; i < this.cpList.length; ++i) {
          if (this.tabsValue == this.cpList[i].name) {
            this.currCpId = this.cpList[i].id;
            this.formFuzzy.cpId = this.currCpId;
            break;
          }
        }
      }
      this.queryParams.pageSize = 20;
      this.queryParams.page = 1;
      this.fetchQueryData();
    },
    syncAlbumHandle() {
      let len = this.multipleSelection.length;
      let count = 0;
      for (let i in this.multipleSelection) {
        let ids = [];
        let idArr = [];
        let newRes = [];
        let idTemp = this.multipleSelection[i].id;
        ids.push(idTemp);
        let param = {
          appId: this.$API.APPID,
          ids: ids,
        };
        this.fetchSourseBookId(param).then((res) => {
          if (res != null) {
            let m = JSON.parse(res);
            for (let j in m) {
              let id = Number(m[j].resId.split(":", 2)[1]);
              idArr.push(id);
            }
            this.fetchAllResByFatherId(idArr).then((res2) => {
              if (res2 != null) {
                newRes = JSON.parse(res2);
                if (newRes.length > 0) {
                  let resArrTemp = {
                    appId: this.$API.APPID,
                    id: idTemp,
                    resList: newRes,
                  };
                  this.addRes2SystemAlbum(resArrTemp).then((res3) => {
                    count += 1;
                    this.checkOver(count, len);
                  });
                } else {
                  count += 1;
                  this.checkOver(count, len);
                }
              } else {
                count += 1;
                this.checkOver(count, len);
              }
            });
          }
        });
      }
    },
    checkOver(count, len) {
      if (count == len) {
        this.$Message.success("操作成功!");
        this.fetchQueryData();
      }
    },
    fetchAllResByFatherId(fatherArr) {
      return new Promise((resolve, reject) => {
        let checkArr = fatherArr;
        let newRes = [];
        let findOver = false;
        let temp = {
          appId: this.$API.APPID,
          src_id: checkArr,
          type: 10,
          pageSize: 500,
        };
        this.fetchChildBook(temp).then((res2) => {
          if (res2 != null) {
            let m2 = JSON.parse(res2).list;
            if (m2.length > 0) {
              checkArr = [];
              for (let k in m2) {
                let tmp = {
                  id: m2[k].id,
                  dbId: m2[k].dbId,
                };
                newRes.push(tmp);
                checkArr.push(m2[k].id);
              }
              let temp2 = {
                appId: this.$API.APPID,
                src_id: checkArr,
                type: 10,
                pageSize: 500,
              };
              this.fetchChildBook(temp2).then((res3) => {
                if (res3 != null) {
                  let m3 = JSON.parse(res3).list;
                  if (m3.length > 0) {
                    for (let k in m3) {
                      let tmp2 = {
                        id: m3[k].id,
                        dbId: m3[k].dbId,
                      };
                      newRes.push(tmp2);
                    }
                    resolve(JSON.stringify(newRes));
                  } else {
                    resolve(JSON.stringify(newRes));
                  }
                } else {
                  reject(null);
                }
              });
            } else {
              resolve(JSON.stringify(m2));
            }
          } else {
            reject(null);
          }
        });
      });
    },

    fetchSourseBookId(param) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/aries-api/album/resIdList", param)
          .then((response) => {
            var m = response.data;
            if (m.result == 0) {
              resolve(JSON.stringify(m.data));
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    fetchChildBook(param) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/aries-api/resource/list", param)
          .then((response) => {
            var m = response.data;
            if (m.result == 0) {
              resolve(JSON.stringify(m.data));
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    addRes2SystemAlbum(param) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/aries-api/album/saveRes", param)
          .then((response) => {
            var m = response.data;
            if (m.result == 0) {
              resolve(JSON.stringify(m.data));
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    gotoAlbum(album) {
      let cpId = Number(album.owner);
      let routeUrl = this.$router.resolve({
        name: "addAlbum",
        query: {
          cpid: cpId,
          albumId: album.id,
          do: "view",
        },
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({
      //   name: "addAlbum",
      //   query: {
      //     cpid: cpId,
      //     albumId: album.id,
      //     do: "view",
      //   },
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../fyd-style.less";
</style>



// WEBPACK FOOTER //
// albumList.vue?0fe646c6